import { DeviceMode, PreviewMode } from './enums'
import type { IBlockMode, IEditorSettings } from './types'

export const INTERACTIVE_MODES = [
  PreviewMode.demo,
  PreviewMode.preview,
  PreviewMode.publicLink,
  PreviewMode.scorm,
]

export const SKELETON_MODE: IBlockMode = {
  previewMode: PreviewMode.skeleton,
  deviceMode: DeviceMode.desktop,
  editorMode: null,
}

export const PREVIEW_MODE: IBlockMode = {
  previewMode: PreviewMode.preview,
  deviceMode: DeviceMode.desktop,
  editorMode: null,
}

export const PDF_MODE: IBlockMode = {
  deviceMode: DeviceMode.desktop,
  previewMode: PreviewMode.pdf,
  editorMode: null,
}

export const DEMO_MODE: IBlockMode = {
  deviceMode: DeviceMode.desktop,
  previewMode: PreviewMode.demo,
  editorMode: null,
}

export const DEFAULT_SETTINGS: IEditorSettings = {
  accentColor: 'rgba(115, 110, 239, 1)',
  backgroundColor: 'rgba(244, 245, 247, 1)',
  divider: true,
  navWidth: 220,
  comments: true,
  tasks: true,

  // V2
  askV2: true,
  gridColor: '#3d8bf4', //'var(--color-blue)',
  flexColor: '#736eef', //'var(--color-violet)',
  absoluteColor: '#36aa55', //'var(--color-green)',
  showGrid: false,
}
